import { createSlice, createAsyncThunk } from "@reduxjs/toolkit";
import axios from "axios";

export const planList = createAsyncThunk('planList', async (data) => {

    try {
        const res = await axios({

            method: 'GET',
            url: process.env.REACT_APP_API_URL + `plan`,
            params: { 'plan_type': data.plan_type },
            headers: { "Content-Type": "application/json", "Authorization": `Bearer ${localStorage.getItem("token")}` }

        })
        return res
    } catch (error) {
        return error.response
    }
})

const planListSlice = createSlice({
    name: 'planList',
    initialState: {
        data: [],
    },
    extraReducers: (builder) => {
        builder.addCase(planList.fulfilled, (state, action) => {
            if (action?.payload?.status === 200) {
                state.data = action.payload.data.data;
            } else if (action?.payload?.status === 401) {
                state.data = [];
                localStorage.clear();
                action?.meta?.arg?.navigate('../login')
            } else {
                state.data = [];
            }
        });
        builder.addCase(planList.rejected, (state, action) => {
            // console.log('reject', action)
        })
    }
})

export default planListSlice.reducer; 